import { useCallback } from 'react';
import { produce } from 'immer';

import useUser from '@/hooks/useUser';

import { WatchlistSorting } from './types';

const DEFAULT_WATCHLIST_SORTING = WatchlistSorting.PERFORMANCE_7D;

export function useWatchlistSorting() {
  const {
    data: user,
    mutate: updateUserSettings,
    setQueryData: setUserSettings,
  } = useUser();

  const watchlistSorting =
    user?.defaultWatchlistSorting ?? DEFAULT_WATCHLIST_SORTING;

  const setWatchlistSorting = useCallback(
    (sorting: WatchlistSorting) => {
      setUserSettings((state) =>
        produce(state, (draft) => {
          draft.defaultWatchlistSorting = sorting;
        })
      );

      updateUserSettings({
        settings: {
          default_watchlist_sorting: sorting,
        },
      });
    },
    [setUserSettings, updateUserSettings]
  );

  return [watchlistSorting, setWatchlistSorting] as const;
}
